import React from "react";
import ReactDOM from "react-dom";
import "./css/index.css";
import "./css/App.css";
import "./css/base.scss";
import "@shopify/polaris/dist/styles.css";
import * as serviceWorker from "./serviceWorker";

import App from "./component/App";

//store redux
import { createStore } from "redux";
import { Provider } from "react-redux";
import myReducers from "./reducers/index";
import { BrowserRouter } from "react-router-dom";
import config from "./config/config";
const store = createStore(myReducers);
const routes = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(routes, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
